export enum PaymentSystemNetwork {
  TRC20,
  ERC20,
  BEP20,
}
